var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.canViewCreditQuotas)?_c('settings-wrapper',{attrs:{"title":"Space settings","section":"Instance Credit Quotas"}},[_c('student-quotas')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }